// assets
import { BookSaved } from 'iconsax-reactjs';

// types
import { NavItemType } from 'types/menu';

// ==============================|| MENU ITEMS - QUESTION BANK LIST ||============================== //

const QuestionBank: NavItemType = {
  id: 'group-question-bank-list',
  title: 'Question Bank',
  type: 'group',
  children: [
    {
      id: 'question-bank-list',
      title: 'Question Bank',
      type: 'item',
      url: '/question-bank',
      icon: BookSaved,
      breadcrumbs: false
    }
  ]
};

export default QuestionBank;
